import { IPagingData, UserRemoteAccessSettingsDto } from '@sr/dto';
import { userRemoteAccessApi } from './api';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';

export const useRemoteAccess = (userId: number) => {
  const { data, isLoading, error } = userRemoteAccessApi.useGetByUserIdQuery(userId);
  return { data, isLoading, error: extractNestJsErrorMessage(error) };
};

export const useUpdateRemoteAccess = (userId?: number) => {
  const [update] = userRemoteAccessApi.useUpdateRemoteAccessSettingsMutation();
  return async (data: UserRemoteAccessSettingsDto) => {
    return update({ userId: userId ?? data.id, data }).unwrap();
  };
};

export const useRemoteAccessList = (paging?: IPagingData, filter?: string) => {
  const { data, isLoading, error } = userRemoteAccessApi.useGetListQuery({ paging, filter });
  return { items: data?.items ?? [], isLoading, error: extractNestJsErrorMessage(error), totalItemsCount: data?.totalItemsCount ?? 0 };
};

export const useDeleteRemoteAccess = () => {
  const [deleteRemoteAccess] = userRemoteAccessApi.useDeleteRemoteAccessSettingsMutation();
  return async (userId: number) => {
    return deleteRemoteAccess(userId).unwrap();
  };
};
